//IMPORTS
import React from "react";
import { Routes, Route } from "react-router-dom";

//PAGES
import { Home, Why, Gallery, Contact, Location } from "./pages";
//SCSS

const AppRouter = () => {
  //

  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/why' element={<Why />} />
      <Route path='/gallery' element={<Gallery />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/location' element={<Location />} />
    </Routes>
  );
};

export default AppRouter;
